import type { MiceProjectView } from '@voll-intelligence/domain';
import { t } from '@web/i18n';
import { Button, Dialog, DialogContent, DialogTitle } from '@web/ui/core';
import { canDeleteProject, useDeleteMiceProject } from '../hooks/use_mice_orders';

/** Item "Apagar evento" do menu ⋯; desabilitado quando algum pedido já entrou na compra. */
export function DeleteProjectMenuItem(
  props: Readonly<{ project: MiceProjectView; className: string; onSelect: () => void }>,
): React.JSX.Element {
  const allowed = canDeleteProject(props.project);
  return (
    <button
      type="button"
      className={`${props.className} text-destructive disabled:cursor-not-allowed disabled:opacity-50`}
      disabled={!allowed}
      title={allowed ? undefined : t('mice.project.delete.blocked')}
      onClick={props.onSelect}
    >
      {t('mice.project.delete.open')}
    </button>
  );
}

/**
 * Confirmação de apagar o evento. Fica fora do menu: fechar o menu desmonta o conteúdo dele, e o
 * diálogo sumiria junto.
 */
export function DeleteProjectDialog(
  props: Readonly<{
    project: MiceProjectView;
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }>,
): React.JSX.Element {
  const remove = useDeleteMiceProject(props.project.id);
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogTitle>{t('mice.project.delete.title')}</DialogTitle>
        <p className="text-meta text-muted-foreground">{t('mice.project.delete.body')}</p>
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={() => {
              props.onOpenChange(false);
            }}
          >
            {t('mice.project.delete.cancel')}
          </Button>
          <Button
            variant="danger"
            disabled={remove.isPending}
            onClick={() => {
              props.onOpenChange(false);
              remove.mutate();
            }}
          >
            {t('mice.project.delete.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
